export const GeometryTypeEnum = Object.freeze({
    lineString: "LineString",
    multiLineString: "MultiLineString",
    polygon: "Polygon",
    multiPolygon: "MultiPolygon",
    point: "Point",
    multiPoint: "MultiPoint"
})
